 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"0ba56b98c7f8ed960b1086363c6113c09799a69a","3":"5fd2d9ed09c8d6512e969445ee30f6d3fd95a6fc","4":"3c4e8b5cf4a6045dc1a7e4e763aa1a0977115b0e","5":"d5668b2db4837089c11665530e412a7e783c8c46","6":"3d53aa20422a87363f8b3ddde9e6394c69841ed8","7":"6f0361fdc566201570507ebf8f39be8ad732b67b","8":"b8fada49f016de40082cca63aec36dc1d875418e","9":"227d60df08653fcdaaad4f0305a2b70e3ce440da","10":"45d929302d1c3ac7caa044c7814c1d0b35baa225","11":"e810926f1ce48e05b1d26c371c805d7b1d7215e7","12":"framework","15":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-landing-page-landing-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-symptoms-campaign-page-symptoms-campaign-page-tsx","23":"component---src-gatsby-theme-gaviscon-pages-404-tsx","24":"component---src-gatsby-theme-gaviscon-templates-article-listing-page-article-listing-page-tsx","25":"component---src-gatsby-theme-gaviscon-templates-product-page-product-page-tsx","26":"component---src-gatsby-theme-gaviscon-templates-quiz-page-quiz-page-tsx","27":"component---src-gatsby-theme-gaviscon-templates-symptom-page-symptom-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"2e5162f938b1c310cb2d","2":"dd2c07ffeee3108a4f77","3":"97d7293e823e520cd070","4":"c07a284ded02326fdf1c","5":"9a845ef1bd3c045a2875","6":"27731482c931557f6a05","7":"8924494df0cea511e244","8":"c4fbd85bb66a76b3ead0","9":"518f378466adb5da729c","10":"4efdc62385d483d823d3","11":"4b17ef65b1e8d6b0d5be","12":"d93b3d22d6c68a1c92dc","15":"db9a6a3d1f4910dcf081","16":"631c0f190d9792784f6c","17":"6059eba566bc548f6c96","18":"9af4c945afc0107ac1c8","19":"d42972f954bfa13a873a","20":"d83f4e79561d47b62270","21":"5946ff51fdd497d74da4","22":"fa9ddf5709dc06b304e7","23":"755254d1ebc45b27b92b","24":"c060d270b402b7f48ea9","25":"59b4bc0bf0137a202493","26":"308c0fdb727d91c5b91c","27":"3b591b45b18920d6eac0","29":"ff267605c3b060c90730"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"0ba56b98c7f8ed960b1086363c6113c09799a69a","3":"5fd2d9ed09c8d6512e969445ee30f6d3fd95a6fc","4":"3c4e8b5cf4a6045dc1a7e4e763aa1a0977115b0e","5":"d5668b2db4837089c11665530e412a7e783c8c46","6":"3d53aa20422a87363f8b3ddde9e6394c69841ed8","7":"6f0361fdc566201570507ebf8f39be8ad732b67b","8":"b8fada49f016de40082cca63aec36dc1d875418e","9":"227d60df08653fcdaaad4f0305a2b70e3ce440da","10":"45d929302d1c3ac7caa044c7814c1d0b35baa225","11":"e810926f1ce48e05b1d26c371c805d7b1d7215e7","12":"framework","15":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-landing-page-landing-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-symptoms-campaign-page-symptoms-campaign-page-tsx","23":"component---src-gatsby-theme-gaviscon-pages-404-tsx","24":"component---src-gatsby-theme-gaviscon-templates-article-listing-page-article-listing-page-tsx","25":"component---src-gatsby-theme-gaviscon-templates-product-page-product-page-tsx","26":"component---src-gatsby-theme-gaviscon-templates-quiz-page-quiz-page-tsx","27":"component---src-gatsby-theme-gaviscon-templates-symptom-page-symptom-page-tsx"}[chunkId]||chunkId) + "." + {"0":"22e7a66a21bfc9f7275c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
